import React, { useEffect, useState } from "react";

import { Modal } from "antd";
import { format, parse } from "date-fns";
import { FaUsers, FaPlus, FaRegEye } from "react-icons/fa";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";

import ModalAddDependent from "../../../pages/home/modals/ModalAddDependent/ModalAddDependent";
import api from "../../../services/api";
import designSystemColors from "../../../styles";
import { notifyError } from "../../../utils/notifications";
import useCheckPermission from "../../../utils/useCheckPermission";
import LoadingElevaty from "../../LoadingElevaty";
import CardDependent from "../CardDependente";
import { ModalEditDependant } from "../ModalEditDependant";
import * as Style from "../style";
import DSButton from "../../DSButton";

function TabDependente({ client, grauParentesco }) {
  const [dependents, setDependents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showMoreItems, setShowMoreItems] = useState(false);
  const [selectedDependent, setSelectedDependent] = useState();
  const [isEditDependentModalOpen, setIsEditDependentModalOpen] =
    useState(false);
  const [updateDependents, setUpdateDepedents] = useState(false);
  const [isOpenAddDependant, setOpenAddDependant] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const hasPermissionView = useCheckPermission("view_personal_data");
  const addDependentPermission = useCheckPermission(
    "permission_add_dependents"
  );
  const hasPermissionToEdit = useCheckPermission("permission_edit_dependents");

  function handleModalAddDependent() {
    setOpenAddDependant(!isOpenAddDependant);
  }

  const handleOpenEditDependentModal = (dependent) => {
    setSelectedDependent(dependent);

    setIsModalOpen(false);
    setTimeout(() => {
      setIsEditDependentModalOpen(true);
    }, 0);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    setLoading(true);
    api
      .get("client_dependants", {
        client_id: client.client.id,
        filter: "all",
        identity: "COND",
      })
      .then((response) => {
        setDependents(response.data);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((err) => {
        setLoading(false);
        notifyError("Erro ao listar dependentes", err.message);
      });
  }, [client, updateDependents]);

  return (
    <>
      {loading ? (
        <Style.WrapperNewLoading>
          <LoadingElevaty width="50px" height="50px" />
        </Style.WrapperNewLoading>
      ) : (
        <div
          className={`content-info ${
            client && dependents.length > 0 ? "userGrid" : ""
          }`}
        >
          {dependents && dependents.length > 0 ? (
            <>
              <div className="content-info-grid-users">
                {dependents?.slice(0, 2).map((dependent) => {
                  const formatedDate = format(
                    parse(dependent.dataNascimento, "yyyy-MM-dd", new Date()),
                    "dd/MM/yyyy"
                  );
                  return (
                    <CardDependent
                      dependent={dependent}
                      formatedDate={formatedDate}
                      grauParentesco={grauParentesco}
                      hasPermissionView={hasPermissionView}
                      showMoreItems={showMoreItems}
                      openEditModal={() =>
                        handleOpenEditDependentModal(dependent)
                      }
                      hasPermissionToEdit={hasPermissionToEdit}
                    />
                  );
                })}
              </div>
              <div
                className="tab-right__item-right"
                style={{ marginTop: "20px" }}
              >
                <div
                  className={`client-edit-options  ${
                    showMoreItems ? "active" : ""
                  }`}
                >
                  {dependents && dependents.length > 2 && (
                    <button
                      type="button"
                      aria-label="btn-email"
                      className="edit"
                      onClick={showModal}
                      style={{
                        backgroundColor: designSystemColors.generalButtons,
                        border: `1px solid ${designSystemColors.generalButtons}`,
                        borderRadius: "8px",
                      }}
                    >
                      <span
                        style={{
                          color: designSystemColors.textGeneralButtons,
                          fontWeight: "bold",
                        }}
                      >
                        <FaRegEye /> Ver todos ({dependents.length})
                      </span>
                    </button>
                  )}

                  {addDependentPermission && (
                    <button
                      type="button"
                      aria-label="btn-add-new"
                      onClick={handleModalAddDependent}
                      style={{
                        border: `1px solid ${designSystemColors.generalButtons}`,
                        borderRadius: "8px",
                      }}
                    >
                      <DSButton
                        style={{
                          color: designSystemColors.textGeneralButtons,
                          fontWeight: "bold",
                          borderRadius: "4px",
                        }}
                        icon={<FaPlus />}
                        isIconAfter
                        buttonText="Adicionar"
                        buttonType="primary"
                        dataTestId="button-add-dependant"
                      />
                    </button>
                  )}
                </div>
              </div>

              <div className="btn-show-more">
                <button
                  type="button"
                  aria-label="btn-show-more"
                  onClick={() => setShowMoreItems(!showMoreItems)}
                >
                  <p>
                    <MdOutlineKeyboardArrowDown
                      className={showMoreItems && "active"}
                    />{" "}
                    {showMoreItems ? "Mostrar menos" : "Mostrar mais"}
                  </p>
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="no-users">
                <p>
                  <FaUsers /> Nenhum dependente cadastrado{" "}
                </p>

                {addDependentPermission && (
                  <button
                    type="button"
                    aria-label="btn-add-new"
                    onClick={handleModalAddDependent}
                    style={{
                      backgroundColor: designSystemColors.generalButtons,
                      border: `1px solid ${designSystemColors.generalButtons}`,
                      borderRadius: "8px",
                    }}
                  >
                    <span
                      style={{
                        color: designSystemColors.textGeneralButtons,
                        fontWeight: "bold",
                      }}
                    >
                      <FaPlus /> Adicionar dependente
                    </span>
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      )}
      <ModalAddDependent
        open={isOpenAddDependant}
        closeModal={() => {
          setOpenAddDependant(false);
        }}
        client={client}
        setUpdateDepedents={() => setUpdateDepedents((prev) => !prev)}
      />

      <ModalEditDependant
        open={isEditDependentModalOpen}
        closeModal={() => {
          setIsEditDependentModalOpen(false);
        }}
        dependent={selectedDependent}
        grauParentesco={grauParentesco}
        client={client}
        setUpdateDepedents={() => setUpdateDepedents((prev) => !prev)}
      />

      {dependents && dependents.length > 2 && (
        <Modal
          title="Dependentes"
          visible={isModalOpen}
          onCancel={handleCancel}
          width={1000}
        >
          <Style.ModalUsers>
            <div
              className="modal-scroll-user"
              style={{
                width: "100%",
                scrollbarWidth: "none",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                padding: "1rem",
              }}
            >
              {dependents?.map((dependent) => {
                const formatedDate = format(
                  parse(dependent.dataNascimento, "yyyy-MM-dd", new Date()),
                  "dd/MM/yyyy"
                );
                return (
                  <CardDependent
                    dependent={dependent}
                    formatedDate={formatedDate}
                    grauParentesco={grauParentesco}
                    hasPermissionView={hasPermissionView}
                    showMoreItems={showMoreItems}
                    openEditModal={() =>
                      handleOpenEditDependentModal(dependent)
                    }
                    isViewMore
                    hasPermissionToEdit={hasPermissionToEdit}
                  />
                );
              })}
            </div>
          </Style.ModalUsers>
        </Modal>
      )}
    </>
  );
}

export default TabDependente;
